module.exports = __webpack_public_path__ + "img/fig07.5e7cb3f0.jpg";